import { FC } from 'react';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useDispatch } from 'react-redux';
import { Avatar } from '@components/avatar';
import { IUser } from '@interface/token';
import { actions } from '@state/global';
import { getURLFromIPFSorHTTP } from '@utils/ipfs';
import { timeAgo } from '@utils/time-ago';
import { getScreenName } from '@utils/user';
import { Box } from '../box';
import { Button } from '../button';
import { Text } from '../text';

export interface ICollaborationNotification {
  notificationid: string;
  timestamp: number;
  viewed: boolean;
  user: IUser;
  platform: string;
  id: number;
}

export const CollaborationNotification: FC<ICollaborationNotification> = ({
  notificationid,
  timestamp,
  viewed,
  user,
  platform,
  id,
}) => {
  const router = useRouter();
  const dispatch = useDispatch();

  const markHasRead = () => {
    dispatch({
      type: actions.GLOBAL_USER_VIEWS_NOTIFICATION,
      payload: notificationid,
    });
  };

  const screenName = getScreenName(user.verified_on_chain, user.screen_name, user.id, user.name);

  return (
    <Link href={`/token/${platform}/${id}`} locale={router.locale} prefetch={false} passHref>
      <a style={{ width: '100%' }}>
        <DropdownMenu.Item asChild onClick={markHasRead}>
          <Box
            css={{
              width: '100%',
              padding: 12,
              cursor: 'pointer',
              '&:hover': {
                backgroundColor: '$secondaryBackground',
              },
              '&:focus': { outline: 'none' },
            }}
          >
            <Box css={{ marginRight: '$space$4' }}>
              <Avatar username={user.id} path={getURLFromIPFSorHTTP(user.profile_image_uri)} size={40} />
            </Box>

            <Box
              css={{
                flexGrow: 1,
                flexDirection: 'column',
                justifyContent: 'space-between',
              }}
            >
              <Box>
                <Text unset css={{ fontSize: 14, color: '$secondaryFill' }}>
                  {screenName} invited you to collaborate.
                </Text>
              </Box>
              <Box>
                <Text unset css={{ color: '$secondaryFill', fontSize: 14 }}>
                  {timeAgo.format(timestamp)}
                </Text>
                {false && (
                  <Box css={{ '&>*': { marginLeft: '$space$4' } }}>
                    <Button variant="underline">Accept</Button>
                  </Box>
                )}
              </Box>
            </Box>
            {!viewed && (
              <Box vertical horizontal>
                <Box
                  css={{
                    width: 8,
                    height: 8,
                    backgroundColor: '$primaryHighlight',
                    borderRadius: 9999,
                  }}
                />
              </Box>
            )}
          </Box>
        </DropdownMenu.Item>
      </a>
    </Link>
  );
};
